<div id='home_therm_section_header'>{{trans('systems.titles.thermostats')}}</div>
<div id='home_therm_section_container'>
    <app-home-thermostat-item *ngFor='let iThermostat of visibleThermostats' [thermostat]='iThermostat'></app-home-thermostat-item>
</div>